import { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { AiOutlineSearch } from "react-icons/ai";
import { AddButton, SubTitle } from "../../Components/CustomComponents";
import Table from "../../Components/Table/Table";
import Toast from "../../Hooks/useToast";
import styles from "./styles/index.module.scss";
// import { ToastContainer, toast } from "react-toastify";

//
import _ from "lodash";
import { Dropdown } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import ModalImage from "react-modal-image";
import { useDispatch } from "react-redux";
import AddTravelModal from "../../Components/Modals/AddTravel";
import DeleteModal from "../../Components/Modals/DeleteModal";
import ViewModal from "../../Components/Modals/ViewModal";
import ViewTravelInsightData from "../../Components/Modals/ViewTravelInsight";
import { updateUsers } from "../../Data/features/userSlice";
import {
  useAddTravelInsightMutation,
  useDeleteTravelInsightMutation,
  useGetAllTravelInsightQuery,
  useUpdateTravelInsightMutation,
} from "../../Data/services/travelInsightApi";

const TravelInsightManagemnet = ({ setPage }) => {
  const [blockModal, setBlockModal] = useState(false);
  const [changePassModal, setChangePassModal] = useState(false);

  const {
    control,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      searchText: "", // or any sensible default
    },
  });
  const searchText = watch("searchText");
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");
  const [viewModal, setViewModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [currentPage, setCurrentPage] = useState(1); // todo

  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllTravelInsightQuery(
      {
        limit: pageSize,
        page: currentPage,
        search: searchText,
        is_paginate: true,
      },
      { refetchOnMountOrArgChange: true }
    );

  const [
    add,
    { isSuccess: isSuccessAdd, isLoading: isLoadingAdd, isError: isErrorAdd },
  ] = useAddTravelInsightMutation();
  const [
    update,
    {
      isSuccess: isSuccessUpdate,
      isLoading: isLoadingUpdate,
      isError: isErrorUpdate,
    },
  ] = useUpdateTravelInsightMutation();

  const [
    deleteData,
    {
      isSuccess: isSuccessDelete,
      isLoading: isLoadingDelete,
      isError: isErrorDelete,
    },
  ] = useDeleteTravelInsightMutation();

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data?.links?.per_page);
      setCurrentPage(data?.links?.current);
      setTotalRecords(data?.links?.total_records);
      setTotalPages(data?.links?.total);
      setRowData(data?.data);
    }
    if (data?.data?.length == 0) {
      setIndicationMessage("No Data available");
    }
  }, [data]);

  useEffect(() => {
    if (data && isSuccess) {
      // console.log("isSuccess = " + data.users);
      dispatch(updateUsers(data.users));
    }
  }, [isSuccess, data, dispatch]);

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "profileImage",
      text: "Image",
      // sort: true,
      headerStyle: {
        width: "100px",
        height: "100px",
      },
      formatter: (cellContent, row) => {
        return (
          <ModalImage
            small={row?.image_url ? row?.image_url : "/images/placeholder.png"}
            large={row?.image_url ? row?.image_url : "/images/placeholder.png"}
            alt=""
            className="height-modal-image"
            // className={`image-fluid object-fit-contain rounded-circle ${
            //   viewImage ? "view-image" : "small-image"
            // }`}
            // onClick={() => setViewImage(true)}
          />
        );
      },
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      headerStyle: {
        width: "200px",
      },
      formatter: (_, row) => {
        return <div className="lc-1">{row?.name || "-"}</div>;
      },
    },
    {
      dataField: "color",
      text: "Color",
      sort: true,
      headerStyle: {
        width: "150px",
      },
    },
    {
      dataField: "prompt",
      text: "Prompt",
      sort: true,
      headerStyle: {
        width: "200px",
      },
      formatter: (_, row) => {
        return <div className="lc-1">{row?.prompt || "-"}</div>;
      },
    },

    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "200px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row?.slug) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              <Dropdown className={`d-inline mx-2 ${styles.choice}`}>
                <Dropdown.Toggle
                  id="dropdown-autoclose-true"
                  className="primary-btn"
                >
                  {/* <IoEllipsisVertical /> */}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    href="#"
                    onClick={() => {
                      setEditedData(row);
                      setViewModal(true);
                    }}
                  >
                    View
                  </Dropdown.Item>
                  {/* <Dropdown.Item href="#" onClick={() => handleUnBLockUser(row)}>UnBlock</Dropdown.Item> */}
                  <Dropdown.Item
                    href="#"
                    onClick={() => {
                      setEditedData(row);
                      setEditModal(true);
                    }}
                  >
                    Edit
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#"
                    onClick={() => {
                      setEditedData(row);
                      setDeleteModal(true);
                    }}
                    className="text-danger"
                  >
                    Delete
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        }
      },
    },
  ];

  const onAdd = async (data) => {
    console.log(data?.image_url, "THETE");
    // return;
    const formData = new FormData();
    if (!_.isString(data?.image_url)) {
      formData.append("image_url", data?.image_url);
    }
    formData.append("name", data?.name);
    formData.append("color", data?.color);
    formData.append("prompt", data?.prompt);

    try {
      let response = await add(formData).unwrap();
      Toast(response?.message, "success");
      setAddModal(false);
      refetch();
    } catch (error) {
      // Handle errors
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during the operation", "error");
      }
    }
  };
  const onUpdate = async (data) => {
    const formData = new FormData();
    formData.append("image_url", data?.image_url);
    formData.append("name", data?.name);
    formData.append("color", data?.color);
    formData.append("prompt", data?.prompt);
    try {
      let response = await update({
        id: editedData?.slug,
        data: formData,
      }).unwrap();
      Toast(response?.message, "success");
      setEditModal(false);
      refetch();
    } catch (error) {
      // Handle errors
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during the operation", "error");
      }
    }
  };

  const handleDelete = async () => {
    try {
      let response = await deleteData(editedData?.slug).unwrap();
      Toast(response?.message, "success");
      setDeleteModal(false);
      refetch();
    } catch (error) {
      // Handle errors
      if (error?.data && error?.data?.message) {
        Toast(error?.data?.message, "error");
      } else {
        Toast("An error occurred during the operation", "error");
      }
    }
  };

  const handleBlockModalClose = () => {
    setBlockModal(false);
    setEditedData("");
  };
  return (
    <div className={styles.MainContainer}>
      {deleteModal ? (
        <DeleteModal
          userText={false}
          handleDeleteModalClose={handleDeleteModalClose}
          data={editedData}
          cnfrmtext={"Delete"}
          text={"This Data"}
          cnfrm={"Confirm"}
          cancel={"Cancel"}
          onDelete={handleDelete}
          isLoading={isLoadingDelete}
        />
      ) : (
        ""
      )}
      {addModal && (
        <AddTravelModal
          handleModalClose={() => setAddModal(false)}
          heading={"Add"}
          onSubmit={onAdd}
          isLoading={isLoadingAdd}
        />
      )}
      {editModal && (
        <AddTravelModal
          handleModalClose={() => setEditModal(false)}
          heading={"Edit"}
          onSubmit={onUpdate}
          isLoading={isLoadingUpdate}
          data={editedData}
        />
      )}

      {viewModal && (
        <ViewModal
          handleClose={() => setViewModal(false)}
          heading={`Prompt`}
          children={<ViewTravelInsightData data={editedData} />}
        />
      )}
      <div className={styles.headerContainer}>
        <div className="w-100 flex-between">
          <SubTitle text={"Travel Insight Management"} />
          <div className="d-flex align-items-center gap-3">
            <div className={styles.search}>
              <div className={styles.searchButton}>
                <AiOutlineSearch color="black" />
              </div>
              <Controller
                control={control}
                name="searchText"
                render={({ field: { onChange, onBlur, value, ref } }) => (
                  <input
                    type="text"
                    placeholder="Search"
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value || ""} // Ensure empty string fallback
                    ref={ref}
                  />
                )}
              />
            </div>
            <div>
              <AddButton text="Add" onClick={() => setAddModal(true)} />
            </div>
          </div>
        </div>

        {
          // <Row>
          //   <Col md={12}>
          //     <Button
          //       classes={`${styles.cardBtn} `}
          //       text="Add User"
          //       onClick={handleAddUser}
          //     ></Button>
          //   </Col>
          // </Row>
        }
      </div>

      <div className={styles.mainTable}>
        <Table
          data={rowData}
          columns={columns}
          indication={indication}
          totalRecords={totalRecords} // todo
          totalPages={totalPages} // todo
          pageSize={pageSize} // todo
          currentPage={currentPage} // todo
          setCurrentPage={setCurrentPage} // todo
          setPageSize={setPageSize} // todo
          refetch={refetch} // todo
        />
      </div>
    </div>
  );
};

export default TravelInsightManagemnet;
